export default (state = { loading: true, list: [], edit: undefined }, action) => {

  switch (action.type) {
    case 'NEWSENTRY_FETCH_BEGIN':
      return { ...state, loading: true };
    case 'NEWSENTRY_FETCH_SUCCESS':
      return { ...state, list: action.payload, loading: false };
    case 'NEWSENTRY_FILTER':
      return { ...state,  filter:action.payload };      
      case 'NEWSENTRY_FILTER_DB':
      return { ...state,  filterDb:action.payload };
    case 'NEWSENTRY_SAVE_SUCCESS':
      return { ...state, list: action.payload, edit: undefined };
    case 'NEWSENTRY_EDIT':
      return { ...state, edit: action.payload };
    case 'NEWSENTRY_CANCEL_EDIT':
      return { ...state, edit: undefined };
    case 'NEWSENTRY_DELETE_SUCCESS':
      return { ...state, list: action.payload, edit: undefined };
    case 'NEWSENTRY_ATTR_EDIT':
      let newsentry = state.edit;
      newsentry[action.payload.attr] = action.payload.value;
      return { ...state, edit: newsentry };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/newsentry/newsentryReducers.js